import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryOwnFinancingModel } from '../models/summary-own-financing.model';



@Injectable()
export class OwnFinancingService extends BaseService<SummaryOwnFinancingModel,SummaryOwnFinancingModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/own-financings');
  }

}
